import styled, { css } from 'styled-components';
import { IconGlyph } from '@/app/common/icons/MaskIcon';

export const lbButton = css`
  cursor: pointer;
  text-align: left;
  position: relative;
  background-color: ${({ theme }) => theme.kallisto.color.common.black[50]};
  border-radius: 9px;
  width: 100%;
  padding: 0px 26px 0px 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: none;
  outline: none;

  ${IconGlyph} {
    position: absolute;
    right: 8px;
    z-index: 1;
    transition-duration: 0.2s, 0.2s;
    transition-timing-function: ease-in, ease-out;
    color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
    @media screen and (min-width: 560px) {
      right: 5px;
    }
  }
  &[aria-disabled='true'] {
    background-color: #f1f1f1;
    border: 1px solid #f1f1f1;
    ${IconGlyph} {
      display: none;
    }
  }
  &[aria-expanded='true'] {
    ${IconGlyph} {
      transform: rotate(180deg);
    }
  }
`;

export const ContainerStyled = styled.div<{ disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;

  &.listbox {
    position: relative;
    [role='listbox'] {
      padding: 0;
      background: #fff;
    }

    [id^='lb_button_'] {
      ${lbButton}
    }
    .input-default {
      color: #697684;
    }

    [id^='lb_list_'] {
      border-top: 0;
      overflow-y: auto;
      overflow-x: hidden;
      position: absolute;
      margin: 0;
      width: 100%;
      z-index: 2;
      border-radius: 0 0 9px 9px;
      &::-webkit-scrollbar-track,
      &::-webkit-scrollbar {
        width: 3px;
        background-color: #f5f5f5;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #c4c4c4;
      }
    }

    .hidden {
      display: none;
    }

    @media screen and (min-width: 560px) {
      [id^='lb_button_'] {
        height: 44px;
      }
      [role='option'] {
        line-height: 44px;
      }
    }

    ul {
      opacity: 0;
      transition:
        transform 0.3s,
        opacity 0.3s;
    }
    [id^='lb_button_'][aria-expanded='true'] + ul {
      opacity: 1;
      display: block;
    }

    .listbox-box-shadow {
      box-shadow:
        0px 24px 32px rgba(0, 0, 0, 0.04),
        0px 16px 24px rgba(0, 0, 0, 0.04),
        0px 4px 8px rgba(0, 0, 0, 0.04),
        0px 0px 10px rgba(0, 0, 0, 0.04);
    }
    .exp_wrapper {
      position: relative;
    }
  }

  &.multilistbox {
    position: relative;
    [role='listbox'] {
      padding: 0;
      background-color: #fff;
      &.two-columns {
        display: flex;
        flex-flow: column wrap;
        align-content: space-between;
      }

      ul {
        li {
          margin-bottom: 24px;
        }
      }
    }

    [id^='lb_button_'] {
      ${lbButton}
    }
    .input-default {
      color: #697684;
    }

    [id^='lb_list_'] {
      border-top: 0;
      overflow-y: auto;
      overflow-x: hidden;
      position: absolute;
      margin: 0;
      width: 100%;
      z-index: 2;
      padding: 0;
      outline: none;
      &::-webkit-scrollbar-track,
      &::-webkit-scrollbar {
        width: 3px;
        background-color: ${({ theme }) => theme.kallisto.color.common.black[50]};
      }
      &::-webkit-scrollbar-thumb {
        background-color: #080808;
      }
    }

    .hidden {
      display: none;
    }

    .listbox-cta {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: 34px;
      line-height: 34px;
      button {
        font-size: 14px;
        font-weight: 400;
        border: none;
        background: #fff;
        color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
        cursor: pointer;
        outline: none;
      }
    }

    .oss-ui-listbox-showmore {
      color: ${({ theme }) => theme.kallisto.color.background.static.backgroundNeutralSubtle};
      cursor: pointer;
      width: 100%;
      text-align: left;
      height: 24px;
      line-height: 24px;
      font-size: 14px;
      font-weight: 400;
    }

    .listbox-box-shadow {
      box-shadow: 0 2px 4px 0 ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
    }
    .exp_wrapper {
      position: relative;
    }

    ul {
      opacity: 0;
      transition:
        transform 0.3s,
        opacity 0.3s;
    }
    [id^='lb_button_'][aria-expanded='true'] + ul {
      opacity: 1;
      display: block;
    }
  }

  &.expanded {
    [id^='lb_list_'] {
      z-index: 1;
      position: relative;
    }
    [role='option'] {
      padding: 0px;
      outline: none;
      &[role='option'].focused {
        background-color: unset;
      }
    }
    .listbox-box-shadow {
      box-shadow: unset;
    }
    .listbox-cta {
      button {
        padding: 0px;
        outline: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
        &:focus {
          background-color: #f4f4f8;
        }
      }
    }
    ul {
      opacity: 1;
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
    `}
`;
